import { tr, trServer, VALIDATION_MSG, LANG } from "./i18n";
import axios from "axios";

// Prefer relative same-origin `/api/...` requests so the app can be hosted
// on ANY domain without a rebuild. Set REACT_APP_BACKEND_URL only when the
// API genuinely lives on a different origin (rare — only for split-host
// deployments where CORS is intentionally in play).
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API_BASE = `${RAW_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token as fallback (for envs that block third-party cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // outputs (reports, PDFs, Excel) follow the user's language
  if ((config.method || "get") === "get") config.params = { ...(config.params || {}), lang: LANG };
  return config;
});

export const MAX_UPLOAD_MB = 20;

/** Checks size and the real image type from the file's first bytes. Returns an error message or "". */
export async function checkImageFile(file) {
  if (file.size > MAX_UPLOAD_MB * 1024 * 1024) return tr("x.file_too_large_named", { p0: file.name, p1: MAX_UPLOAD_MB });
  const b = new Uint8Array(await file.slice(0, 12).arrayBuffer());
  const s = (i, n) => String.fromCharCode(...b.slice(i, i + n));
  const isJpg = b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff;
  const isPng = b[0] === 0x89 && s(1, 3) === "PNG";
  const isWebp = s(0, 4) === "RIFF" && s(8, 4) === "WEBP";
  const isHeic = s(4, 4) === "ftyp";
  if (!(isJpg || isPng || isWebp || isHeic)) return tr("x.not_a_real_image", { p0: file.name });
  return "";
}

export function formatApiError(err) {
  if (err?.response?.status === 413) return tr("x.file_is_too_large_the_maximum_size_is_mb", { p0: MAX_UPLOAD_MB });
  const detail = err?.response?.data?.detail;
  if (detail == null) return tr("x.something_went_wrong");
  if (typeof detail === "string") return trServer(detail);
  if (Array.isArray(detail))
    return VALIDATION_MSG() || detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string") return trServer(detail.msg);
  return trServer(String(detail));
}
